import * as React from "react"
import * as moment from "moment"
import { IActivity } from "./ActivitiesTable";

export interface IExpadableAcitivityItem {
    activity: IActivity,
    isExpandable: boolean,
}



const ExpandableActivityItem = (props: IExpadableAcitivityItem) => {

    const [isExpanded, setIsExpanded] = React.useState(false);

    const toggleExpand = () => {
        setIsExpanded(isExpanded => !isExpanded);
    }

    const getScoreBackgroundColor = (score: number) => {
        score = Math.ceil(score / 2);
        const colors = ['#c15248', '#f47366', '#f08840', '#f08840', '#ffb945', '#7fcb61'];
        if (score >= 0 && score <= 5) return colors[score];
        return colors[2];
    }


    return (
        <div className={"activity-item"}>
            <div className="activity-item-rows">
                <span className={"activity-time"}>{props.activity.activityTime}</span>
                {/* <span className={"acitivity-type"}>{activity.activityType}</span> */}
                <span className={"activity-details"}>{props.activity.activityDetails}</span>
                {props.activity.score ? <span className={"activity-score"} style={{
                    backgroundColor: getScoreBackgroundColor(props.activity.score),
                    height: isExpanded ? '40px' : '20px',
                    width: isExpanded ? '40px' : '20px',
                    fontSize: isExpanded ? '22px' : '13px'
                }}> {props.activity.score} </span>:null}
                {props.isExpandable ? <span className={`activity-expand `} onClick={toggleExpand} style={{ transform: `rotate(${isExpanded ? 180 : 0}deg)` }}>
                    <img src="/images/icons/down-arrow.svg" alt="expand" />
                </span>:null}
                <div className="activity-expanded" style={{
                    opacity: isExpanded ? 1 : 0,
                    height: isExpanded ? 'auto' : 0,
                    padding: isExpanded ? '27px 0' : 0
                }}>
                    {props.activity.intitalReading ? <div className="activity-expanded__item">
                        <span className="activity-expanded__item--primary">{props.activity.intitalReading}</span>
                        <span className="activity-expanded__item--sub-primary">&nbsp;mg/dl</span>
                        <div className="activity-expanded__item--secondary">Initial Reading</div>
                    </div>:null}
                    {props.activity.peakReading ? <div className="activity-expanded__item">
                        <span className="activity-expanded__item--primary">{props.activity.peakReading}</span>
                        <span className="activity-expanded__item--sub-primary">&nbsp;mg/dl</span>
                        <div className="activity-expanded__item--secondary">Peak Reading</div>
                    </div>:null}
                    {props.activity.difference || props.activity.difference === 0 ? <div className="activity-expanded__item">
                        <span className="activity-expanded__item--primary">{props.activity.difference}</span>
                        <span className="activity-expanded__item--sub-primary">&nbsp;mg/dl</span>
                        <div className="activity-expanded__item--secondary">Difference</div>
                    </div>:null}
                    {props.activity.timeOverTarget || props.activity.timeOverTarget === 0? <div className="activity-expanded__item">
                        <span className="activity-expanded__item--primary">{props.activity.timeOverTarget}</span>
                        <span className="activity-expanded__item--sub-primary">&nbsp;mins</span>
                        <div className="activity-expanded__item--secondary">Time Over Target</div>
                    </div>:null}
                </div>
            </div>
        </div>


    )

}

export default ExpandableActivityItem;
